<template>
  <div class="hl-overlay" @click.self="!persistent && $emit('close')">
    <div class="hl-confirm-card">
      <button
        type="button"
        class="hl-close hl-close--outline"
        @click="$emit('close')"
      >
        &times;
      </button>

      <h3 class="hl-confirm-title">{{ title }}</h3>
      <slot />

      <div class="hl-confirm-actions">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
// Generic confirmation dialog for the Event Highlights feature
// (download / redownload / delete). Caller provides the body (default slot)
// and the buttons (#actions slot); chrome + styling are shared.
import "@/assets/css/event-highlights.css";

export default {
  name: "HighlightDialog",
  props: {
    title: { type: String, required: true },
    // When true, clicking outside the card doesn't close the dialog —
    // only the close (×) button does. Used for the Downloading dialog so a
    // stray backdrop click doesn't kill an in-flight download.
    persistent: { type: Boolean, default: false },
  },
  emits: ["close"],
};
</script>
